import { DuExcelUtilities } from 'driscolls-react-utilities';
import React from 'react';

const fileInput = (returnFunction, ref, statusFunction) => {
    return (
        <input
            ref={ref}
            type="file"
            id="input"
            onChange={(t) => {
                DuExcelUtilities.HandleFiles(t.currentTarget.files, returnFunction, statusFunction);
            }}
            accept=".xls,.xlsx,.xlsb"
        />
    );
};

const DrcExcelUtilities = {
    FileInput: fileInput
};

export default DrcExcelUtilities;
